
import { all } from 'redux-saga/effects';

import {
    authFlow ,
    watchActivate,
    watchCreateAccount,
    watchChangePassword,
    watchEditAccount,
    watchResetPassword,
    watchResetPasswordRequest,
    watchSendActivation,
} from '../common/client/sagas/auth';

import {
    watchGetArticles
} from './articles';

import {
    watchGetUserPermissions
} from '../common/client/sagas/mysliveckyportal/userPermissions';

import {
    checkSessionWorkFlow
} from '../common/client/sagas/mysliveckyportal/checkSession';

import history from '../history';

export default function* rootSagas() {
    const options = {
        history: history,
    };

    yield all([
        watchGetArticles(options),
        watchGetUserPermissions(options),
        watchActivate(options),
        watchChangePassword(options),
        watchCreateAccount(options),
        watchEditAccount(options),
        watchResetPassword(options),
        watchResetPasswordRequest(options),
        watchSendActivation(options),
        checkSessionWorkFlow(options),

        authFlow({
            ...options,
            afterLogoutUrl: '/'
        })
    ]);
}
